import type { ManualBillingReportRow } from '../types/manualBilling';

export const MANUAL_BILLING_CSV_HEADERS = [
  'source',
  'firstName',
  'lastName',
  'participantType',
  'lessonName',
  'lessonId',
  'lessonType',
  'termName',
  'eventName',
  'eventDate',
  'periodStart',
  'periodEnd',
  'bookingStatus',
  'paymentStatus',
  'periodTotalDue',
  'totalDue',
] as const;

export function buildManualBillingCsvRows(
  rows: ManualBillingReportRow[]
): Record<string, string | number>[] {
  return rows.map((row) => ({
    source: row.source,
    firstName: row.firstName,
    lastName: row.lastName,
    participantType: row.participantType ?? '',
    lessonName: row.lessonName ?? '',
    lessonId: row.lessonId ?? '',
    lessonType: row.lessonType ?? '',
    termName: row.termName ?? '',
    eventName: row.eventName ?? '',
    eventDate: row.eventDate ?? '',
    periodStart: row.periodStart ?? '',
    periodEnd: row.periodEnd ?? '',
    bookingStatus: row.bookingStatus ?? '',
    paymentStatus: row.paymentStatus,
    periodTotalDue: row.periodTotalDue ?? '',
    totalDue: row.totalDue,
  }));
}

export function buildManualBillingCsvFilename(
  periodStart?: string,
  periodEnd?: string
): string {
  const today = new Date().toISOString().slice(0, 10);
  const start = periodStart ?? 'all';
  const end = periodEnd ?? 'all';
  return `manual-billing_${start}_to_${end}_${today}.csv`;
}
